import type { PartnerStatisticsSchema } from "@biteasy/contracts";
import type { z } from "zod";
import { formatCurrency } from "@/util/format";

interface PartnerStatisticsCardsProps {
	statistics: z.infer<typeof PartnerStatisticsSchema>;
}

export function PartnerStatisticsCards({
	statistics,
}: PartnerStatisticsCardsProps) {
	const stats = [
		{
			label: "Total Earnings",
			value: formatCurrency(statistics.totalEarnings, statistics.currency),
			description: "Lifetime revenue",
		},
		{
			label: "Paid Out",
			value: formatCurrency(statistics.paidOut, statistics.currency),
			description: "Already transferred",
		},
		{
			label: "Pending Payout",
			value: formatCurrency(statistics.pendingPayout, statistics.currency),
			description: "Accrued, not yet paid",
		},
		{
			label: "Attributions",
			value: statistics.totalAttributions.toLocaleString(),
			description: "Total installations",
		},
	];

	return (
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
			{stats.map((stat) => (
				<div
					key={stat.label}
					className="rounded-xl border border-base-content/10 bg-base-100 p-6"
				>
					<div className="text-sm font-medium text-base-content/60">
						{stat.label}
					</div>
					<div className="mt-2 text-3xl font-bold text-base-content">
						{stat.value}
					</div>
					<div className="mt-1 text-xs text-base-content/50">
						{stat.description}
					</div>
				</div>
			))}
		</div>
	);
}
